import script from "./expertiseView.vue?vue&type=script&setup=true&lang=js"
export * from "./expertiseView.vue?vue&type=script&setup=true&lang=js"

import "./expertiseView.vue?vue&type=style&index=0&id=76dffea0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76dffea0"]])

export default __exports__